// extracted by mini-css-extract-plugin
export default {"switch":"Options_switch__CNB6G","slider":"Options_slider__qU18z"};